module.exports = __webpack_public_path__ + "static/media/dha.6ef684fd.ogg";